import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8083";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    const user = getStoredUser();
    const token = user?.token;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const apiMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong";
    return Promise.reject({
      ...error,
      apiMessage,
      apiStatus: error?.response?.data?.status,
      apiData: error?.response?.data?.data,
    });
  }
);

export const getApiErrorMessage = (error, fallback = "Something went wrong") =>
  error?.apiMessage ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

export default axiosInstance;
